import { CertificationService } from '@/user/apis'
import { MonthlyExamInfo } from '@/user/models/certification/monthly-exam'
import { ExamDetail } from '@/user/models/exam/exam-detail'
import { CertificationExam } from '@/user/models/exam/changeable-exam'
import { toAsync, pipe, map, toArray } from '@fxts/core'

const CertificationStore = {
  namespaced: true,
  state: () => ({
    monthlyExam: [],
    monthlyDetailExam: [],
    changableExam: [],
  }),
  mutations: {
    monthlyExam(state, payload) {
      state.monthlyExam = payload
    },
    monthlyDetailExam(state, payload) {
      state.monthlyDetailExam = payload
    },
    changableExam(state, payload) {
      state.changableExam = payload
    },
    clearMonthlyExam(state) {
      state.monthlyExam = []
      state.monthlyDetailExam = []
    },
  },
  actions: {
    async getMonthlyCertificationExam({ commit }, yearMonth) {
      try {
        const data = await CertificationService.getMonthlyCertificationExam(yearMonth)

        commit('monthlyExam', new MonthlyExamInfo(data))
      } catch (error) {
        // error
      }
    },
    async getMonthlyCertificationDetialExam({ commit }, yearMonth) {
      try {
        const examDetails = await pipe(
          CertificationService.getMonthlyCertificationExam(yearMonth),
          toAsync,
          map((exam) => exam.id),
          map((id) => CertificationService.getCertificationExamDetails(id)),
          map((data) => new ExamDetail(data)),
          toArray
        )

        commit('monthlyDetailExam', examDetails)
      } catch (error) {
        // error
      }
    },
    async getChangableExam({ commit }, currentExamId) {
      try {
        const data = await CertificationService.getChangableExamByExamId(currentExamId)

        commit(
          'changableExam',
          data.map((obj) => new CertificationExam(obj))
        )
      } catch (error) {
        // error
      }
    },
  },

  getters: {
    monthlyCertificationExams(state) {
      return state.monthlyExam
    },
    monthlyCertificationDetailExams(state) {
      return state.monthlyDetailExam
    },
    changableExams(state) {
      return state.changableExam
    },
  },
}

export default CertificationStore
